const CustomInput = ({
  placeholder,
  type,
  value,
  onChange,
  onBlur,
  name = "name",
}) => {
  return (
    <input
      className="h-[45px] w-full text-[14px] rounded-[2px] px-[10px] border border-[#D9D9D9] focus:outline-none focus:ring-0 focus:ring-offset-0 focus:border-[#D9D9D9]"
      type={type}
      name={name}
      value={value}
      onBlur={onBlur}
      onChange={onChange}
      placeholder={placeholder}
    />
  );
};

export default CustomInput;
